export const SET_NOTIFICATION_RESPONSE = 'SET_NOTIFICATION_RESPONSE';
export const SET_ALL_NOTIFICATION_RESPONSES = 'SET_ALL_NOTIFICATION_RESPONSES';
export const REMOVE_NOTIFICATION_ITEM = 'REMOVE_NOTIFICATION_ITEM';

export const setNotificationResponse = (payload: Record<string, any>) => ({
  type: SET_NOTIFICATION_RESPONSE,
  payload,
});
